// @flow

import React, { Component } from 'react';
import Header from "../Header";
import Footer from "../Footer";
import s from './Cookies.scss';

export default class Cookies extends Component {
  render() {
    //let textId = '5bbb4e142787e8adc1583739';
   // let textCMS = this.props.texts.filter(i => i._id == (textId || ''))[0] || false;
    let cookiesText = `<p>1. Administrator za pośrednictwem strony internetowej wykorzystuje pliki Cookies.</p>
    <p>2. Informacje zgromadzone na podstawie plików Cookies wykorzystywane są w celach właściwej optymalizacji działania strony internetowej, a także w celach statystycznych oraz reklamowych.</p>
    <p>3. Pliki Cookies rejestrują aktywność Użytkownika strony internetowej rozpoznając urządzenie, dzięki czemu strona internetowa wyświetlana jest w sposób zoptymalizowany do indywidualnych preferencji Użytkownika.</p>
    <p>4. Stosowane na stronie internetowej rozwiązania są bezpieczne dla urządzeń Użytkowników korzystających ze strony internetowej Administratora. Nie jest możliwe przedostanie się do Urządzeń Użytkowników niebezpiecznego lub złośliwego oprogramowania.</p>
    <p>5. Administrator wykorzystuje dwa typy plików Cookies:</p>
    <p class="indent-para>1. Cookies sesyjne: to pliki, które są przechowywane na urządzeniu Użytkownika i pozostają tam do momentu zakończenia sesji danej przeglądarki. Zapisane informacje są wówczas trwale usuwane z pamięci Urządzenia. Mechanizm Cookies sesyjnych nie pozwala na pobieranie jakichkolwiek danych osobowych ani żadnych informacji poufnych z urządzenia Użytkownika.</p>
    <p class="indent-para>2. Cookies trwałe: są przechowywane na urządzeniu Użytkownika i pozostają tam do momentu ich skasowania. Zakończenie sesji danej przeglądarki lub wyłączenie Urządzenia nie powoduje ich usunięcia z urządzenia. Mechanizm Cookies trwałych nie pozwala na pobieranie jakichkolwiek danych osobowych ani żadnych informacji poufnych z urządzenia Użytkownika.</p>

    <p>Sposoby określenia warunków przechowywania lub uzyskiwania dostępów do Cookies</p>

    <p class="indent-para">1. Użytkownik ma możliwość ograniczenia lub wyłączenia dostępu plików Cookies do swojego urządzenia. W przypadku skorzystania z tej opcji korzystanie ze Serwisu będzie możliwe, poza funkcjami, które ze swojej natury wymagają plików Cookies.</p>
    <p class="indent-para">2. Użytkownik może samodzielnie i w każdym czasie zmienić ustawienia dotyczące plików Cookies, określając warunki ich przechowywania i uzyskiwania dostępu przez pliki Cookies do urządzenia Użytkownika. Zmiany ustawień, o których mowa powyżej, Użytkownik może dokonać za pomocą ustawień przeglądarki internetowej lub za pomocą konfiguracji usługi. Ustawienia te mogą zostać zmienione w szczególności w taki sposób, aby blokować automatyczną obsługę plików Cookies w ustawieniach przeglądarki internetowej bądź informować o każdorazowym zamieszczeniu Cookies na urządzeniu. Szczegółowe informacje o możliwości i sposobach obsługi plików Cookies dostępne są w ustawieniach oprogramowania (przeglądarki internetowej).</p>
    <p class="indent-para">3. Użytkownik może w każdej chwili usunąć pliki Cookies korzystając z dostępnych funkcji w przeglądarce internetowej, której używa.</p>
    <p class="indent-para">4. Ograniczenie stosowania plików Cookies, może wpłynąć na niektóre funkcjonalności dostępne na stronie internetowej Administratora</p>`
    if (cookiesText) {
      return (
        <React.Fragment>
          
          <Header />
        <div className="cookies-container">
          <h1 className="medium-heading">STOSOWANIE PLIKÓW COOKIES</h1>

          <section className="container">
            <div dangerouslySetInnerHTML={{ __html: cookiesText }}></div>
          </section>
        </div>
        <Footer />
        </React.Fragment>
      );
    } else {
      return (<div></div>);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Cookies/Cookies.js